var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import MUIDivider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core';
import Row from '../Row';
import units from '../theme/units';
var useStyles = makeStyles(function () { return ({
    textSeparator: {
        width: 'auto',
        flexGrow: 1,
    },
    text: {
        padding: units.yx(0, 0.3),
    },
    'kind-spaced-m': {
        margin: units.yx(1, 0),
    },
    'kind-spaced-l': {
        margin: units.yx(1.5, 0),
    },
}); });
var Divider = function (_a) {
    var _b;
    var text = _a.text, kind = _a.kind, className = _a.className, _c = _a.dividerProps, dividerProps = _c === void 0 ? {} : _c, rest = __rest(_a, ["text", "kind", "className", "dividerProps"]);
    var classes = useStyles();
    var divider = (React.createElement(MUIDivider, __assign({}, rest, dividerProps, { className: cx(className, (_b = {},
            _b[classes["kind-" + kind]] = Boolean(kind),
            _b[classes.textSeparator] = Boolean(text),
            _b)) })));
    // If there is no provided text, fall back to MUI divider
    if (!text) {
        return divider;
    }
    return (React.createElement(Row, { justify: "space-between", alignItems: "center" },
        divider,
        React.createElement(Typography, { className: classes.text }, text),
        divider));
};
export default Divider;
//# sourceMappingURL=index.js.map